import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { IInsiderMembershipInformation } from "@faire/web-api--source/indigofair/insider/IInsiderMembershipInformation";

export const getInsiderMemershipInformation = ():
  | IInsiderMembershipInformation
  | undefined => getGlobalProperty("insiderMembershipInformation");
